var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBottom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.8125C6.26903 0.8125 0.8125 6.26903 0.8125 13C0.8125 19.731 6.26903 25.1875 13 25.1875C19.731 25.1875 25.1875 19.731 25.1875 13C25.1875 6.26903 19.731 0.8125 13 0.8125ZM12.3371 18.3504C12.5129 18.5262 12.7514 18.625 13 18.625C13.2486 18.625 13.4871 18.5262 13.6629 18.3504L17.4129 14.6004C17.779 14.2343 17.779 13.6407 17.4129 13.2746C17.0468 12.9085 16.4532 12.9085 16.0871 13.2746L13.9375 15.4242L13.9375 8.3125C13.9375 7.79473 13.5178 7.375 13 7.375C12.4822 7.375 12.0625 7.79473 12.0625 8.3125L12.0625 15.4242L9.91291 13.2746C9.5468 12.9085 8.95321 12.9085 8.58709 13.2746C8.22097 13.6407 8.22097 14.2343 8.58709 14.6004L12.3371 18.3504Z",
    fill: "#F26A1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottom);
export default __webpack_public_path__ + "static/media/arrow-bottom.36afac830f1e7383ff67e045919fda58.svg";
export { ForwardRef as ReactComponent };